import { QueryKey } from '@/configs/queryKeys';
import { Attachment, BaseEntity, Translations } from '@/types/types';
import { ProductTypeCategory } from './ProductTypeCategoryApi';
import { Component } from './ComponentApi';
import { Accessory } from './AccessoryApi';
import EntityApi from './EntityApi';

export enum ProductTypeStatus {
	ENABLED = 'enabled',
	DISABLED = 'disabled',
}

export enum DimensionType {
	AUTO = 'auto',
	MANUAL = 'manual',
}

export interface DimensionsConfig {
	name: string;
	shortName: string;
	width?: {
		type: DimensionType;
		formula: string;
		min: number;
		max: number;
		priceModifier: {
			amount: number;
			from: number;
		};
	};
	height?: {
		type: DimensionType;
		formula: string;
		min: number;
		max: number;
		priceModifier: {
			amount: number;
			from: number;
			interval: number;
		};
	};
}

export enum ProductTypeTemplate {
	SIMPLE = 'simple',
	ADVANCED = 'advanced',
}

export interface ProductType extends BaseEntity {
	name: string;
	price: number;
	image?: Attachment;
	listOrder: number;
	translations: Translations<{
		name: string;
	}>;
	vatRate: number;
	components: Component[];
	accessories: Accessory[];
	category: ProductTypeCategory;
	dimensionsConfig: DimensionsConfig[];
	template: ProductTypeTemplate;
}

class ProductTypeApi extends EntityApi<ProductType> {
	constructor() {
		super(QueryKey.productTypes);
	}
}

export default new ProductTypeApi();
